import { type FC } from "react";

import { ActionButton, ActionButtonIntent, ActionButtonSize } from "widgets";

import { type Tool } from "../../../../graphql.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";
import TableCellText from "./core/TableCellText.js";

const ToolAdminCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value) {
    return null;
  }

  const tool: Tool = props.data.tool;
  const { context } = props;
  const adminContext = context.adminContext;
  const asLink = tool.requireInternetConnection ? adminContext?.hasInternetConnection : true;
  const tooltip =
    tool.requireInternetConnection && !asLink ? props.value + " (Missing Server Internet Connection)" : undefined;

  return asLink ? (
    <TableCell>
      <ActionButton
        onPress={() => (props as any).handleToolClicked(tool)}
        label={`Launch ${props.value}`}
        intent={ActionButtonIntent.Outlined}
        size={ActionButtonSize.Small}
        isDisabled={!!tooltip}
        tooltip={tooltip}
      />
    </TableCell>
  ) : (
    <TableCellText {...props} tooltip={props.value} />
  );
};

export { ToolAdminCell };
export default ToolAdminCell;
